import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import Typography from "housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography"
import GiftUpAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/GiftUpAppIcon'
import React from 'react'
import GiftUpButton from '../OtherComponents/GiftUpButton.jsx'

const GiftUpStrategy = {
  previewInfo: {
    name: "Gift Up!",
    iconSvg: <GiftUpAppIcon size={'xlarge'} />,
    newTab: true
  },
  headerInfo: {
    name: 'Gift Up!',
    category: 'Payments',
    details:
      <div>
        Gift Up! is the simplest way to sell your business’ gift cards online. All delivered by email, instantly.
        <br/>
        <br/>
        Create beautiful, branded gift cards and start selling them immediately on your website,
        Facebook, Instagram, Twitter, or wherever you reach your customers.
        You can even add a link in your emails!  Setup takes five minutes.
        <br/>
        <br/>
        <ul>
          <li>Fully automated</li>
          <li>You get paid immediately</li>
          <li>No monthly fees, no setup fees</li>
          <li>Any website, any currency</li>
          <li>Sell fixed value gift cards (e.g. $100) or custom values (where your customers choose)</li>
          <li>Sell specific product and services, or generally redeemable gift cards</li>
        </ul>
      </div>,
    iconSvg: <GiftUpAppIcon size="xlarge" />
  },
  price: {
    price: '',
    description:
      <Grid container direction="column" spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            No monthly fee
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="left" variant="body1">
            No setup fee
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="left" variant="body1">
            3.49% transaction fee
          </Typography>
        </Grid>
      </Grid>,
    hideToggle: true,
    appActionButton: <GiftUpButton />
  },
}

export default GiftUpStrategy
